import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { FilterVariantProps } from '@silverfort/sf-components/dist/Dropdown/interfaces';

import { INCIDENT_STATUS_OPTIONS, INCIDENT_TYPE_OPTIONS, SEVERITIES_OPTIONS } from './FilterOptions';

interface Params {
    selectedSeverities?: number[];
    setSelectedSeverities: Dispatch<SetStateAction<number[] | undefined>>;
    types?: number[];
    setTypes: Dispatch<SetStateAction<number[] | undefined>>;
    selectedStatuses?: number[];
    setSelectedStatuses: Dispatch<SetStateAction<number[] | undefined>>;
    hiddenTypes?: number[];
}

const useGetFilters = ({
    selectedSeverities,
    setSelectedSeverities,
    selectedStatuses,
    setSelectedStatuses,
    types,
    setTypes,
    hiddenTypes
}: Params) => {
    const [filters, setFilters] = useState<FilterVariantProps<string | number>[]>();

    useEffect(() => {
        setFilters([
            {
                items: SEVERITIES_OPTIONS,
                onChange: setSelectedSeverities as (val?: (number | string) | (number | string)[]) => void,
                selectedItems: selectedSeverities,
                title: 'Severity',
                variant: 'filter'
            },
            {
                items: INCIDENT_TYPE_OPTIONS.filter((type) => !hiddenTypes?.includes(type.value)),
                onChange: setTypes as (val?: (number | string) | (number | string)[]) => void,
                selectedItems: types,
                title: 'Type',
                variant: 'filter'
            },
            {
                items: INCIDENT_STATUS_OPTIONS,
                onChange: setSelectedStatuses as (val?: (number | string) | (number | string)[]) => void,
                selectedItems: selectedStatuses,
                title: 'Status',
                variant: 'filter'
            }
        ]);
    }, [selectedSeverities, setSelectedStatuses, setTypes, selectedSeverities, selectedStatuses, types, hiddenTypes]);

    return filters;
};

export default useGetFilters;
